import { BookingGuarantee } from './guarantees';

interface GuaranteeItemProps {
  guarantee: BookingGuarantee;
  showDetails: boolean;
}

const GuaranteeItem = ({ guarantee, showDetails }: GuaranteeItemProps) => {
  return (
    <div
      className={
        showDetails
          ? 'flex gap-4 rounded-lg bg-gray-0 p-4'
          : 'flex items-center gap-2'
      }
    >
      <div
        className={
          showDetails
            ? 'h-fit w-fit rounded-lg bg-secondary-main/30 p-2 text-secondary-main'
            : 'p-0'
        }
      >
        <div className={'h-5 w-5 text-secondary-main lg:h-6 lg:w-6'}>
          {guarantee.icon}
        </div>
      </div>
      <div className="flex flex-col items-start gap-2">
        <span
          className={
            showDetails
              ? 'text-md font-medium text-gray-9'
              : 'text-sm font-medium'
          }
        >
          {guarantee.label}
        </span>
        {showDetails && (
          <span className="text-sm text-gray-7">{guarantee.details}</span>
        )}
      </div>
    </div>
  );
};

export default GuaranteeItem;
